// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1406":"674302742936f9b6","6467":"0bd9ffd88332afe7"}[chunkId] + ".css";
};